import { render, staticRenderFns } from "./MoleculeFeedSectionContentCardEditionDesign5.vue?vue&type=template&id=1cc6779b&"
import script from "./MoleculeFeedSectionContentCardEditionDesign5.vue?vue&type=script&lang=js&"
export * from "./MoleculeFeedSectionContentCardEditionDesign5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports